import React, { ReactElement } from 'react';
import { SvgIcon, withStyles } from '@material-ui/core';
import { mainColor, UNIT } from '../../constants';
import Spinner from '../Spinner';

const CustomSvgIcon = withStyles(() => ({
  root: {
    width: UNIT * 6,
    height: UNIT * 6
  }
}))(SvgIcon);

type EmptyViewProps = {
  src?: React.ComponentType<any>,
  title?: string,
  text?: string,
  children?: ReactElement,
  viewBox?: string,
  className?: string,
  isLoading?: boolean,
  htmlColor?: string,
}

function EmptyView({ src: SvgComponent, title, text, children, viewBox = '0 0 712 712', className, isLoading = false }: EmptyViewProps) {
  return (
    <div className='centered  w-100 align-items-center'>
      {isLoading ? (
        <Spinner style={{ color: mainColor.secondaryColor, margin: UNIT * 5 }} />) : (
        <>
          <CustomSvgIcon
            className={className}
            viewBox={viewBox}
            htmlColor={mainColor.secondaryColor}>
            {SvgComponent && <SvgComponent />}
          </CustomSvgIcon>

          <div className='p-2 pb-4 d-flex flex-column justify-content-center align-items-center'>
            <h4 className='bold-text text-center'>{title}</h4>
            <p style={{ color: '#a8aab4' }} className='m-0 text-center'>
              {text}
            </p>
          </div>
          {children}
        </>
      )}
    </div>
  );
};
export default EmptyView;